import { string } from 'prop-types';
import React from 'react';
import './styles.scss';

const SubTitle = ({ children }) => {
  return (
    <p className="subtitle">{ children }</p>
  );
}

SubTitle.propTypes = {
  children: string.isRequired
};

export default SubTitle;
